import "./App.css";
import Dropdown from "./components/Dropdown/Dropdown";
import ChatLog from "./components/ChatLog/ChatLog";
import ChatUserInput from "./components/ChatUserInput/ChatUserInput";
import ClearChat from "./components/Clearchat/ClearChat";
import Description from "./components/Description/Description";
import "./normal.css";
import { useState, useEffect } from "react";

function App() {
  useEffect(() => {
    getModels();
  }, []);

  const [input, setInput] = useState("");
  const [models, setModels] = useState([]);
  const [currentModel, setCurrentModel] = useState("x-ai/grok-4-fast");
  const [currentModelDescription, setCurrentModelDescription] = useState(
    "Grok 4 is xAI's latest reasoning model with a 256k context window. It supports parallel tool calling, structured outputs, and both image and text inputs. Note that reasoning is not exposed, reasoning cannot be disabled, and the reasoning effort cannot be specified. Pricing increases once the total tokens in a given request is greater than 128k tokens. See more details on the [xAI docs](https://docs.x.ai/docs/models/grok-4-0709)"
  );
  const [chatLog, setChatLog] = useState([
    {
      user: "ai",
      message: "How can I help you today?",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  async function getModels() {
    try {
      const response = await fetch(
        "https://catatua-bot-be.onrender.com/models"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Models data:", data);

      const freeModels = (data.models || []).filter(
        (model) =>
          model.id.toLowerCase().includes("free") ||
          model.name.toLowerCase().includes("free") ||
          (model.pricing && model.pricing.tier === "free")
      );

      setModels(freeModels);
    } catch (error) {
      console.error("Error fetching models:", error);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!input.trim() || isLoading) return;

    const newChatLog = [...chatLog, { user: "user", message: input }];
    setChatLog(newChatLog);
    setInput("");
    setIsLoading(true);

    try {
      const response = await fetch("https://catatua-bot-be.onrender.com/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: input,
          currentModel: currentModel,
          stream: true,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let fullMessage = "";

      const streamingIndex = newChatLog.length;
      setChatLog((prev) => [...prev, { user: "ai", message: "" }]);

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        fullMessage += chunk;

        setChatLog((prevChatLog) => {
          const updatedChatLog = [...prevChatLog];
          updatedChatLog[streamingIndex] = {
            user: "ai",
            message: fullMessage,
          };
          return updatedChatLog;
        });
      }
    } catch (error) {
      console.error("Streaming error:", error);
      setChatLog((prevChatLog) => [
        ...prevChatLog,
        {
          user: "ai",
          message: `Sorry, something went wrong: ${error.message}`,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="App">
      <aside className="sidemenu">
        <ClearChat setChatLog={setChatLog} />
        <Dropdown
          currentModel={currentModel}
          setCurrentModelDescription={setCurrentModelDescription}
          setCurrentModel={setCurrentModel}
          models={models}
          currentModelDescription={currentModelDescription}
        />
      </aside>

      <section className="chatbox">
        <ChatLog chatLog={chatLog} isLoading={isLoading} />
        <ChatUserInput
          input={input}
          setInput={setInput}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </section>
    </div>
  );
}

export default App;
